module.exports = require('./lib');


//////////////////
// WEBPACK FOOTER
// ./~/react-autosize-textarea/index.js
// module id = 921
// module chunks = 0